module.exports = __webpack_public_path__ + "media/images/ww25-f394b8b63976a0109631501012ef35dc.svg";